import { getAxiosInstance } from "../utils/apiClient";
import { getTokens } from "../utils/tokens";

const axiosInstance = getAxiosInstance();

export const sendVideoRequestAPI = (data) => {
  return new Promise((resolve, reject) => {
    const tokens = getTokens();

    axiosInstance
      .post("/api/video-request", data, {
        headers: {
          [process.env.REACT_APP_AUTH_TOKEN]: `Bearer ${tokens.access_token}`,
          [process.env.REACT_APP_FIREBASE_AUTH_TOKEN]:
            `Bearer ${tokens.firebase_token}`,
        },
      })
      .then((res) => resolve(res.data))
      .catch((err) => reject(err));
  });
};

export const acceptVideoRequestAPI = (requestId) => {
  return new Promise((resolve, reject) => {
    const tokens = getTokens();

    axiosInstance
      .patch(`/api/video-request/${requestId}/accept`, {}, {
        headers: {
          [process.env.REACT_APP_AUTH_TOKEN]: `Bearer ${tokens.access_token}`,
          [process.env.REACT_APP_FIREBASE_AUTH_TOKEN]:
            `Bearer ${tokens.firebase_token}`,
        },
      })
      .then((res) => resolve(res.data))
      .catch((err) => reject(err));
  });
};

export const rejectVideoRequestAPI = (requestId) => {
  return new Promise((resolve, reject) => {
    const tokens = getTokens();

    axiosInstance
      .patch(`/api/video-request/${requestId}/reject`, {}, {
        headers: {
          [process.env.REACT_APP_AUTH_TOKEN]: `Bearer ${tokens.access_token}`,
          [process.env.REACT_APP_FIREBASE_AUTH_TOKEN]:
            `Bearer ${tokens.firebase_token}`,
        },
      })
      .then((res) => resolve(res.data))
      .catch((err) => reject(err));
  });
};

export const setVideoRequestPendingAPI = (requestId) => {
  return new Promise((resolve, reject) => {
    const tokens = getTokens();

    axiosInstance
      .patch(`/api/video-request/${requestId}/set-pending`, {}, {
        headers: {
          [process.env.REACT_APP_AUTH_TOKEN]: `Bearer ${tokens.access_token}`,
          [process.env.REACT_APP_FIREBASE_AUTH_TOKEN]:
            `Bearer ${tokens.firebase_token}`,
        },
      })
      .then((res) => resolve(res.data))
      .catch((err) => reject(err));
  });
};

export const completeVideoRequestAPI = (requestId, videoUrl) => {
  return new Promise((resolve, reject) => {
    const tokens = getTokens();

    axiosInstance
      .patch(`/api/video-request/${requestId}/complete`, {
        videoUrl,
      }, {
        headers: {
          [process.env.REACT_APP_AUTH_TOKEN]: `Bearer ${tokens.access_token}`,
          [process.env.REACT_APP_FIREBASE_AUTH_TOKEN]:
            `Bearer ${tokens.firebase_token}`,
        },
      })
      .then((res) => resolve(res.data))
      .catch((err) => reject(err));
  });
};

export const getVideoRequestsAPI = (userId) => {
  return new Promise((resolve, reject) => {
    const tokens = getTokens();

    axiosInstance
      .get(`/api/video-request/user/${userId}`, {
        headers: {
          [process.env.REACT_APP_AUTH_TOKEN]: `Bearer ${tokens.access_token}`,
          [process.env.REACT_APP_FIREBASE_AUTH_TOKEN]:
            `Bearer ${tokens.firebase_token}`,
        },
      })
      .then((res) => resolve(res.data))
      .catch((err) => reject(err));
  });
};

export const cancelVideoRequestAPI = (requestId) => {
  return new Promise((resolve, reject) => {
    const tokens = getTokens();

    axiosInstance
      .patch(`/api/video-request/${requestId}/cancel`, {}, {
        headers: {
          [process.env.REACT_APP_AUTH_TOKEN]: `Bearer ${tokens.access_token}`,
          [process.env.REACT_APP_FIREBASE_AUTH_TOKEN]:
            `Bearer ${tokens.firebase_token}`,
        },
      })
      .then((res) => resolve(res.data))
      .catch((err) => reject(err));
  });
};

export const getVideoRequestStatsAPI = (userId) => {
  return new Promise((resolve, reject) => {
    const tokens = getTokens();

    axiosInstance
      .get(`/api/video-request/stats/${userId}`, {
        headers: {
          [process.env.REACT_APP_AUTH_TOKEN]: `Bearer ${tokens.access_token}`,
          [process.env.REACT_APP_FIREBASE_AUTH_TOKEN]:
            `Bearer ${tokens.firebase_token}`,
        },
      })
      .then((res) => resolve(res.data))
      .catch((err) => reject(err));
  });
};

export const getLastVideoRequestByUsernameAPI = (username) => {
  return new Promise((resolve, reject) => {
    const tokens = getTokens();

    axiosInstance
      .post(
        "/api/video-request/last-by-username",
        { username },
        {
          headers: {
            [process.env.REACT_APP_AUTH_TOKEN]: `Bearer ${tokens.access_token}`,
            [process.env.REACT_APP_FIREBASE_AUTH_TOKEN]:
              `Bearer ${tokens.firebase_token}`,
          },
        }
      )
      .then((res) => resolve(res.data))
      .catch((err) => reject(err));
  });
};

export const uploadCompletedVideoAPI = (requestId, videoFile) => {
  return new Promise((resolve, reject) => {
    const tokens = getTokens();
    const formData = new FormData();
    formData.append('video', videoFile);

    axiosInstance
      .post(`/api/video-request/${requestId}/upload`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
          [process.env.REACT_APP_AUTH_TOKEN]: `Bearer ${tokens.access_token}`,
          [process.env.REACT_APP_FIREBASE_AUTH_TOKEN]:
            `Bearer ${tokens.firebase_token}`,
        },
      })
      .then((res) => resolve(res.data))
      .catch((err) => reject(err));
  });
};
